export const ONSITE_DOCUMENTS_LIST = [
  {
    id: 'approvedPlans',
    title: 'Approved plans on site?',
    subtitle: 'Make sure the items matched the plans.',
    state: null,
  },

  {
    id: 'inspectionCard',
    title: 'Inspection card/log on site?',
    subtitle: '',
    state: null,
  },
  {
    id: 'siTestDocuments',
    title: 'Special Inspections Log and/or Shop Drawings on site?',
    subtitle:
      'Applicable only if special inspections were required. If not applicable select YES',
    state: null,
  },
];

export const ONSITE_DOCUMENTS_FAIL_MATRIX = [false, false, false];
